import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { ThirdPartyState } from "./type";

export const getThirdPartyDetails = createAsyncThunk(
  "web/get-third-party-details",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/management/wallets`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_THIRD_PARTY_DETAILS(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getAllThirdPartyVendors = createAsyncThunk(
  "web/get-third-party-vendors",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/third-party-vendor-controls`);

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;

        thunkAPI.dispatch(SET_VENDOR_CONTROL_PANEL(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getAllVendors = createAsyncThunk(
  "web/get-all-available-vendors",
  async (_, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/third-party-vendor-controls/available`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;

        thunkAPI.dispatch(SET_AVAILABLE_VENDOR(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const createNewVendor = createAsyncThunk(
  "web/create-new-vendor",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.post(
        "/admin/third-party-vendor-controls",
        payload,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const updateVendor = createAsyncThunk(
  "web/update-vendor",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.put(
        `/admin/third-party-vendor-controls/${payload?.id}`,
        payload.body,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const deleteVendor = createAsyncThunk(
  "web/delete-vendor",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.delete(
        `/admin/third-party-vendor-controls/${payload}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const initialState: ThirdPartyState = {
  loading: false,
  sila_loading: false,
  payaza: {},
  blaze: [],
  zojapay: {},
  third_party_info: {},
  vendor_control_panel: [],
  vendors: [],
  loading_vendors: false,
  updating_vendors: false,
  // initialize other state properties
};

export const thirdPartySlice = createSlice({
  name: "third-party",
  initialState,

  reducers: {
    SET_THIRD_PARTY_DETAILS: (state, action) => {
      state.payaza = action.payload?.payaza;
      state.blaze = action.payload?.blaaiz;
      state.bridge = action.payload?.bridge;
      state.zojapay = action.payload?.zojapay;
      state.third_party_info = action.payload;
    },
    SET_VENDOR_CONTROL_PANEL: (state, action) => {
      state.vendor_control_panel = action.payload;
    },
    SET_AVAILABLE_VENDOR: (state, action) => {
      state.vendors = action.payload;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(getThirdPartyDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getThirdPartyDetails.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getThirdPartyDetails.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(getAllThirdPartyVendors.pending, (state) => {
      state.loading_vendors = true;
    });
    builder.addCase(getAllThirdPartyVendors.fulfilled, (state) => {
      state.loading_vendors = false;
    });
    builder.addCase(getAllThirdPartyVendors.rejected, (state) => {
      state.loading_vendors = false;
      return initialState;
    });
    builder.addCase(getAllVendors.pending, (state) => {
      state.loading_vendors = true;
    });
    builder.addCase(getAllVendors.fulfilled, (state) => {
      state.loading_vendors = false;
    });
    builder.addCase(getAllVendors.rejected, (state) => {
      state.loading_vendors = false;
      return initialState;
    });
    builder.addCase(createNewVendor.pending, (state) => {
      state.updating_vendors = true;
    });
    builder.addCase(createNewVendor.fulfilled, (state) => {
      state.updating_vendors = false;
    });
    builder.addCase(createNewVendor.rejected, (state) => {
      state.updating_vendors = false;
      return initialState;
    });
    builder.addCase(updateVendor.pending, (state) => {
      state.updating_vendors = true;
    });
    builder.addCase(updateVendor.fulfilled, (state) => {
      state.updating_vendors = false;
    });
    builder.addCase(updateVendor.rejected, (state) => {
      state.updating_vendors = false;
      return initialState;
    });
    builder.addCase(deleteVendor.pending, (state) => {
      state.updating_vendors = true;
    });
    builder.addCase(deleteVendor.fulfilled, (state) => {
      state.updating_vendors = false;
    });
    builder.addCase(deleteVendor.rejected, (state) => {
      state.updating_vendors = false;
      return initialState;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_THIRD_PARTY_DETAILS,
  SET_VENDOR_CONTROL_PANEL,
  SET_AVAILABLE_VENDOR,
} = thirdPartySlice.actions;

export default thirdPartySlice.reducer;
